import { render, staticRenderFns } from "./403-page.vue?vue&type=template&id=03265c7a&scoped=true"
import script from "./403-page.vue?vue&type=script&lang=js"
export * from "./403-page.vue?vue&type=script&lang=js"
import style0 from "./403-page.vue?vue&type=style&index=0&id=03265c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03265c7a",
  null
  
)

export default component.exports